import { render } from "./FileTypeComponent.vue?vue&type=template&id=0637a392&scoped=true"
import script from "./FileTypeComponent.vue?vue&type=script&lang=js"
export * from "./FileTypeComponent.vue?vue&type=script&lang=js"

import "./FileTypeComponent.vue?vue&type=style&index=0&id=0637a392&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0637a392"]])

export default __exports__